import { environmentDefault } from './environment.default';
import { Environment } from './Type';

export const environment: Environment = {
  ...environmentDefault,

  debug: false,
  production: true,
  devtoolsEnabled: 'true',

  home: 'https://moje.o2.cz/',

  buildProperties: {
    bffAuthUrl: 'https://api-a-moje.o2.cz/api/auth',
    adobeLaunchPath: 'https://assets.adobedtm.com/b8db4c46addb/d1bcba65d545/launch-EN54244f013533469cbbcabcf7c4f9b231.min.js',
    backlinkCookieLastVisitedPageDomain: '.o2.cz',
    guiGeneralPlannedOutageUrl: 'https://www.o2.cz/osobni/odstavka-mojeo2',
    apiRequestTimeoutInSec: '30',
  },
  propertyUrl: 'https://api-eme-a-moje.o2.cz/api/bffgw-property',
  propertyTTL: 18000000,

  urlConfig: {
    ...environmentDefault.urlConfig,
    billingManagement: {
      propertyKey: 'bff.billingmanagement.url',
      mockEnabled: false,
    },
    eBillDownloader: {
      propertyKey: 'BSLEBILL.url.downloadBaseUrl',
      mockEnabled: false,
    },
  },

  translate: {
    oneCRM: {
      url: 'https://moje.o2.cz/api/cms-resource/public/v1/resource/LANGTEXT/mo2-crmServices',
      rootKey: 'mo2-crmServices',
    },
  },

  properties: {
    'FUNNEL.url': 'https://poruchy.o2.cz/funnel/deeplink',
    'FUNNEL.history.url': '/history/ttid/${ttid}',
    'TTS.detail.url': 'http://tts-gf.cz.o2/tds/pl.do?idPL=${ttid}',
    'gui.journalingHistory.loadPagesCount.Init': '3',
    'gui.journalingHistory.pageSize': '10',
    'bff.response.cacheTTL.default': '60000',
    'bff.response.cacheTTL.codebook': '1800000',
    'gui.entityManagement.searching_contactPerson.maxResultsToDisplay':
      '3',
    'gui.entityManagement.searching_contactPerson.pageSize': '3',
    'gui.entityManagement.searching_contactPerson.guiScreenId':
      '2-30-5',
    'gui.documentList.loadPagesCount.Init': '5',
    'gui.documentList.pageSize': '20',
    'gui.financialDocumentList.loadPagesCount.Init': '5',
    'gui.financialDocumentList.pageSize': '20',
    'onecrm.gui_billingManagement.monthStatementDetail.reclamationURL':
      'https://www.o2.cz/podpora/vyuctovani/reklamace#c-akordeony-a131362',
    'gui.paymentList.pageSize': '20',
    'gui.financialInfo.dayCount.firstDay': '1',
    'gui.financialInfo.dayCount.DaysInBetween': '2, 3, 4',
    'gui.financialInfo.dayCount.moreThanDays': '4',
    'onecrm.billing.firstDayForCurrentMonth': '4',
    'gui.OTPVerification.hideSendOTPAgainFor': '10',
    'gui.AllInvoices.dateSelection.NumberOfMonths': '18',
    'gui.billing.monthDetail.interactiveInvoice.pageSize': '20',
    'gui.isProdEnvironment': 'true',
    'gui.accesses.maxDirectRolesCount': '5',
    'BSLEBILL.url.downloadBaseUrl': 'https://api-ebill-a-moje.o2.cz/api/ebill-download/private/v1',
    'document.signosoft.url': 'https://signosoftp.o2.cz/O2SignoSoft/load?docid=:guid&docidhash=:docIdHash&targetSystem=ONE-CRM&sourceurl=:sourceUrl',
    'gui.journalingHistory.loadPageCount.contactPersonSearch':
      '1',
    'gui.journalingHistory.loadPageSize.contactPersonSearch':
      '20',
    'gui.journalingHistory.minCharsToSearch': '3',
    'gui.backlink.defaultPage': '/web/o2/userdashboard',
    'gui.backlink.backlinker': '/backlink',
    'gui.timer.upcomingLogout': '55',
    'gui.timer.logout': '65',
    'gui.loginPage.url': 'https://login-a-moje.o2.cz/cas-external/login',
    'oneportal.deeplinker.url': 'https://moje.o2.cz/deeplink',
    'onecrm.general.adobeAnalyticsEnabled': 'true',
    'gui.contactPerson.attributeEmptyValueSubstitutionText': 'NEVYPLNĚNO,NEVYPLNENO',
    'onecrm.entityAccessManagement.AccessToEntity.ComRulesURL':
      'https://www.o2.cz/osobni/-a73695?field=data',
    'gui.AddressSearch.url': 'https://api-a-moje.o2.cz/api/address/public/v2/addresses',
    'gui.AddressSearch.insertInterruptTime': '5',
    'gui.AddressSearch.nCharStart': '3',
    'bff.user-mgw.url': 'https://api-eme-a-moje.o2.cz/api/bffgw-user',
    'gui.journalingHistory.loadPageSize.internalUserSearch': '20',
    'gui.journalingHistory.loadPageCount.internalUserSearch':
      '1',
    'global.url.cms.langtexts': 'https://api-a-moje.o2.cz/api/cms-resource/public/v1/resource/LANGTEXT/mo2-crmServices',
    'ncas.login.hostname': 'https://api-a-moje.o2.cz/cas/login',
    'bff.cms-resource.url': 'https://api-a-moje.o2.cz/api/cms-resource/',
    'bff.kahl.url': 'https://api-a-moje.o2.cz/api/kahl/public/v1',
    'bff.journaling.url': 'https://api-eme-a-moje.o2.cz/api/bffgw-journaling',
    'bff.documents.url': 'https://api-eme-a-moje.o2.cz/api/bffgw-document',
    'bff.customer.url': 'https://api-eme-a-moje.o2.cz/api/bffgw-customer',
    'bff.user.url': 'https://api-eme-a-moje.o2.cz/api/bffgw-user-apf',
    'bff.useraccess.url': 'https://api-eme-a-moje.o2.cz/api/bffgw-useraccess',
    'bff.codebook.url': 'https://api-eme-a-moje.o2.cz/api/bffgw-codebook',
    'bff.financial-info.url': 'https://api-eme-a-moje.o2.cz/api/bffgw-financial-info',
    'bff.sharedobjects.url': 'https://api-a-moje.o2.cz/api/shared-objects/public/v1',
    'bff.internaluser.url': 'https://api-eme-a-moje.o2.cz/api/bffgw-user-apf',
    'bff.usercontext.url': 'https://api-eme-a-moje.o2.cz/api/bffgw-user-context',
    'bff.tariffspace.url': 'https://api-eme-a-moje.o2.cz/api/bffgw-tariff-space',
    'bff.asset.url': 'https://api-eme-a-moje.o2.cz/api/bffgw-asset',
    'bff.customeraccount.url': 'https://api-eme-a-moje.o2.cz/api/bffgw-customer-account',
    'gui.billing.MonthStatementClaim.step1.pageSize': '20',
    'gui.otpVerification.sendOtpAgain.timeout': '10',
    'document.signosoft.crmSourceURL': 'http://cip-prod.cz.o2:8101/o2.cz/cip/svc/customermgmt/customercontactmgmt/DocumentProcessingNotification/1.0',
    'document.signosoft.sha256Key': '%DOCUMENT_SIGNOSOFT_SHA256KEY%',
    'gui.entityAccessManagement.AccessToEntity.ComRulesURL': 'https://www.o2.cz/osobni/-a73695?field=data',
    'gui.footer.customerSupport.url': 'https://www.o2.cz/osobni/pece-a-podpora',
    'gui.footer.privacy.url': 'https://www.o2.cz/osobni/202009-soukromi/',
    'gui.footer.aboutUs.url': 'https://www.o2.cz/spolecnost/',
    'gui.footer.contacts.url': 'https://www.o2.cz/osobni/kontakty',
    'gui.footer.mojeO2App.url': 'https://www.o2.cz/osobni/moje-o2#m-download-moje-o2',
    'saveDocumentToLocalStore.uploadFile.maxFileSize': '50',
    'gui.documentList.documentsForConfirmation.allowedListOfRoles':
      'E110, E210, E220, E221, E222',
    'gui.general.plannedOutage.url': '%GUI_GENERAL_PLANNEDOUTAGE_URL%',
    'gui.entityManagement.custAccount_payment.InfoUR': 'https://www.o2.cz/osobni/podpora/jak-platit-za-sluzby-o2/jak-a-kdy-zaplatit#accordion-a37171-a37172',
    'onecrm.pzForIframeApf2.url': 'https://moje.o2.cz/deeplink?command=IMO2PZAPF2&action=showCustomerRequestInFrame&view=detail&customerRequestTicketRefNo=',
    'onecrm.entity_dashboard.UrlToInfoserviceDetail': 'http://infoservis.cz.o2/detail/',
    'bff.offer.url': 'https://api-eme-a-moje.o2.cz/api/bffgw-offer',
    'bff.notifyevent.url': 'https://api-eme-a-moje.o2.cz/api/bffgw-notify-event',
    'bff.paymentgateway.url': 'https://api-eme-a-moje.o2.cz/api/bffgw-payment-gateway',
    'bff.crmfin.url': 'https://api-eme-a-moje.o2.cz/api/bffgw-crmfin',
    'bff.crm.url': 'https://api-eme-a-moje.o2.cz/api/bffgw-crm',
    'bff.billingmanagement.url': 'https://api-ebill-a-moje.o2.cz/api/ebill/private/v1',
    'onecrm.pzForIframeApf2.createCr.url': 'https://moje.o2.cz/deeplink?command=IMO2PZAPF2&action=createCustomerRequestInFrame',
    'onecrm.gui_billingManagement.monthStatementDetail.residentStatementURL':
      'https://www.o2.cz/podpora/vyuctovani/pruvodce',
    'onecrm.gui_billingManagement.monthStatementDetail.smbStatementURL':
      'https://www.o2.cz/podpora/vyuctovani/pruvodce',
    'onecrm.gui_billingManagement.monthStatementDetail.statementURL':
      'https://www.o2.cz/podpora/vyuctovani/pruvodce',
    'gui.entityAccessManagement.AccessToEntity.timeToGetFile':
      '2',
    'api.request.timeoutInSec.common': '30',
    'gui.general.planned.outage.url': 'https://www.o2.cz/osobni/odstavka-mojeo2',
    'gui.waitForSearchingStarts.sec': '1',
    'api.request.timeoutInSec.ebill.doDownload': '300',
    'gui.journalingHistory.redat.url': 'https://redat.o2.cz/experience/index.php?nav_lev1=catalog&nav_lev2=reclist&nav_force=1&property=set&name0=showInters&value0=',
    'gui_accessManagement_cuContPersons.pageSize': '10',
    'mo2care.intDashb.partnerprogram.url': 'https://moje.o2.cz/internal/partner-program',
    'api.request.timeoutInSec.ebill.step1': '300',
    'gui.externalHeader.action.omnichannelUrl': '/omnichannel',
    'gui.internalHeader.action.mySalesUrl': 'https://omnichannel.o2.cz',
    'bsl.omni.getNavigationLinks.url': 'https://omnichannel.o2.cz/api/omnichannel/public/v1/bsl-omnichannel-nav/get-nav',
    'bff.invoices.url': 'https://api-eme-a-moje.o2.cz/api/bff-invoices',
    'onecrm.billing.financialDocumentList.quantityOfMaxSelectedDocuments':
      '24',
    'gui.financialDocumentList.CashPayment.maxAccounts': '20',
    'gui.otp.phoneNoOTP.dummy.default': '420702001004',
    'gui.otp.validationTimeReserveSeconds': '7200',
    'gui.loginPageMfa.active': 'true',
    'gui.billing.mojeO2platba.chargeCodes': '322;',
    'apf.deeplinker.url': `https://api-a-moje.o2.cz/api/deeplink/public/v1/deeplink`,
    'mo2Care.PaymentsOverview.internal.deeplink': '?command=I_PAYMENT_OVERVIEW',
    'mo2Care.PaymentsOverview.external.deeplink': '?command=E_PAYMENT_OVERVIEW',
    'mo2Care.CpDashboard.deeplink': '?command=ECPDASH&cpRefNo=',
    'gui.general.BFFDIGITVCAPTURE.contactPerson.missingName':
      'NEVYPLNENO',
  },
};
